import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m6.121 11.148 4.375-4.375a.843.843 0 0 1 1.23 0 .843.843 0 0 1 0 1.23l-2.87 2.872h8.394a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875H8.855l2.872 2.898a.843.843 0 0 1 0 1.23.843.843 0 0 1-1.23 0L6.12 12.38a.843.843 0 0 1 0-1.23"
    }, null, -1)
  ]))]))
}
export default { render: render }